/**
 * HUB-E — KPI stock + visibilité M1 / M2.
 */
import React from 'react';
import { magasinScopeLabel } from '../../utils/stock/stockDisplay';
import MagasinBadge from '../MagasinBadge';

export default function ActiviteStockKpiStrip({ kpis, magasinId, magasinCounts }) {
  const scope = magasinScopeLabel(magasinId);

  return (
    <div className="space-y-3" data-testid="activite-stock-kpi">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs text-[var(--rm-gray-500)]">Périmètre :</span>
        {magasinId ? (
          <MagasinBadge code={magasinId} size="sm" />
        ) : (
          <span className="rm-badge rm-badge--muted" data-testid="activite-stock-scope-all">{scope}</span>
        )}
      </div>

      {!magasinId && magasinCounts && (
        <div className="grid grid-cols-2 gap-2 text-xs" data-testid="activite-stock-kpi-magasin-breakdown">
          {['M1', 'M2'].map((code) => (
            <div
              key={code}
              className="rounded-lg border px-3 py-2"
              style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
            >
              <MagasinBadge code={code} size="sm" />
              <span className="text-[var(--rm-gray-400)] ml-2">
                {magasinCounts[code]?.ruptures ?? 0} rupt. · {magasinCounts[code]?.faible ?? 0} faible
              </span>
            </div>
          ))}
        </div>
      )}

      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 text-sm">
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-stock-ruptures">
          <div className="text-xs text-[var(--rm-gray-500)]">Ruptures</div>
          <div className="font-bold text-[var(--rm-red-light)]">{kpis?.ruptures ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-stock-faible">
          <div className="text-xs text-[var(--rm-gray-500)]">Stock faible</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.faible ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-stock-mouvements">
          <div className="text-xs text-[var(--rm-gray-500)]">Mouvements</div>
          <div className="font-bold text-[var(--rm-white)]">{kpis?.mouvements ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-stock-entrees">
          <div className="text-xs text-[var(--rm-gray-500)]">Entrées (qté)</div>
          <div className="font-bold text-[var(--rm-success)]">{kpis?.entrees ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-stock-sorties">
          <div className="text-xs text-[var(--rm-gray-500)]">Sorties (qté)</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.sorties ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-stock-articles">
          <div className="text-xs text-[var(--rm-gray-500)]">Articles</div>
          <div className="font-bold text-[var(--rm-white)]">{kpis?.articles ?? 0}</div>
        </div>
      </div>
    </div>
  );
}
